import { createContext, useContext, useEffect, type ReactNode } from 'react';

export type StudentLocale = 'zh-CN' | 'en-US';

const StudentLocaleContext = createContext<StudentLocale>('zh-CN');

export function StudentLocaleProvider({ locale, children }: { locale: StudentLocale; children: ReactNode }) {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  return <StudentLocaleContext.Provider value={locale}>{children}</StudentLocaleContext.Provider>;
}

export function useStudentLocale() {
  return useContext(StudentLocaleContext);
}

export function studentText(locale: StudentLocale, english: string, chinese: string) {
  return locale === 'zh-CN' ? chinese : english;
}
